import styled from 'styled-components';

export const Container = styled.div`
  overflow-y: auto;
  height: 100vh;
  width: 100%;
  padding: 48px 0;
`;

export const Iframe = styled.iframe`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;

  /* display: ${({ show }) => (show ? 'block' : 'none')}; */
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.6s ease-in-out;
`;
